/**
 * Telling a dead link apart from a bad code — the vetter-link twin of the
 * organization app's `guest-failure.ts`.
 *
 * A wrong or stale *code* is retryable. A revoked or replaced *link* is
 * terminal: no code will ever work, so the email form must not come back
 * (step 1 answers neutrally, so it can't warn them either).
 *
 * STOPGAP: `vetterJobLogin` returns only `success` + prose, so this reads the
 * prose. `messageKey` is checked first so that swapping over needs no change.
 */

export type LinkFailureKind = 'terminal' | 'retryable';

const TERMINAL_KEYS = new Set(['LINK_REVOKED', 'LINK_EXPIRED', 'VETTER_LINK_REVOKED']);

/** Deliberately narrow: a bare "expired" is usually the one-time code, which is retryable. */
const TERMINAL_PATTERNS =
	/revoked|replaced|link (?:has )?expired|link is no longer|no longer (?:valid|active)/i;

export function classifyLinkFailure(
	message?: string | null,
	messageKey?: string | null
): LinkFailureKind {
	if (messageKey && TERMINAL_KEYS.has(messageKey.toUpperCase())) return 'terminal';
	if (message && TERMINAL_PATTERNS.test(message)) return 'terminal';
	return 'retryable';
}
